import { focusOutline, hasCheckedBgColor } from "../../Resources/CSS/styling";

export default function Switch({ label, description, onChange, checked }) {
    return (
      <div className="flex items-center justify-between gap-3">
        <div className={`group relative inline-flex w-11 shrink-0 rounded-full bg-gray-100 p-0.5 outline-offset-2 ${focusOutline} ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out has-[:checked]:bg-green-400 group-[&:not(:has(:checked))]:bg-gray-500 has-[:focus-visible]:outline has-[:focus-visible]:outline-2`}>
          <span className="size-5 rounded-full group-has-[:checked]:bg-gray-50 group-[&:not(:has(:checked))]:bg-gray-400 shadow-sm ring-1 ring-hoodle-900/5 transition-transform duration-200 ease-in-out group-has-[:checked]:translate-x-5" />
          <input
            id="annual-billing"
            name="annual-billing"
            type="checkbox"
            aria-labelledby="annual-billing-label"
            aria-describedby="annual-billing-description"
            className="absolute -inset-0.5 cursor-pointer w-full min-w-full appearance-none opacity-0 focus:outline-none"
            checked={checked}
            onChange={onChange}
          />
        </div>
  
        <div className="text-sm">
          <label id="annual-billing-label" className="font-medium text-gray-400">
            {label}
          </label>
        </div>
      </div>
    )
  }
  